const users = {
  getUserById(id) {
    return this.request(`/users/${id}`);
  },

  setUser(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/users', Object.assign(defaults, { data: JSON.stringify(data) }));
  },

  getUserProfile(token) {
    const authToken = token || this.getStoragedToken();
    const defaults = {
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request('/1/users/me', defaults);
  },

  setUserProfile(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/profile', Object.assign(defaults, { data }));
  },

  resetPasswordProfile(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/password', Object.assign(defaults, { data }));
  },

  fetchUserProfile() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/profile', defaults);
  },

  refreshToken(token) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        grant_type: 'refresh_token',
        refresh_token: token,
      }),
    };
    return this.request('/1/users/oauth/token', defaults);
  },
  createAWSAccount(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/contract/create', Object.assign(defaults, { data }));
  },
  getLogin(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(
      '/1/users/oauth/token',
      Object.assign(defaults, { data: JSON.stringify(data) }),
      false,
      false,
      false
    );
  },

  confirmAdmin(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(
      '/1/users/confirm_admin',
      Object.assign(defaults, { data: JSON.stringify(data) }),
      false,
      false,
      false
    );
  },

  confirmAdminWithBcrypt(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(
      '/1/users/confirm_bcrypt',
      Object.assign(defaults, { data: JSON.stringify(data) }),
      false,
      false,
      false
    );
  },
  activateUser(password, passwordConfirmation, token, isReset = false) {
    const path = isReset ? '/1/passwords/reset_password' : '/1/users/confirm_account';
    const tokenName = isReset ? 'reset_password_token' : 'confirmation_token';
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        password,
        password_confirmation: passwordConfirmation,
        [tokenName]: token,
      }),
    };

    return this.request(path, defaults);
  },

  resetUser(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/passwords/request_reset_token', Object.assign(defaults, { data }));
  },

  resetPasswordWithToken() {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/passwords/request_admin_reset_token', defaults);
  },

  fetchUserScanConfig(userId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/users/${userId}/scan_config`, defaults);
  },

  changeRoll(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/company/change_role', Object.assign(defaults, { data }));
  },

  activateLdap(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/users/company/activate_ldap', Object.assign(defaults, { data }));
  },

  checkEula(token) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(`/1/users/check_eula?confirmation_token=${token}`, defaults);
  },

  confirmEula(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request('/1/users/put_eula', Object.assign(defaults, { data }));
  },
  getSProjectCountDetail(userId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/users/settings_user?user_id=${userId}`, defaults);
  },
  searchProject(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/search_users_projects', Object.assign(defaults, { data }));
  },
  saveUserProject(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.requestHtml('/1/users/save_users_projects', Object.assign(defaults, { data }));
  },
  getSCompanyList() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.request('/1/customer_company', defaults);
  },
  getUserDetail(userId) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/users/${userId}/edit`, defaults);
  },
  updateUser(userId, data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/users/${userId}`, Object.assign(defaults, { data }));
  },
  deleteUser(userId) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/users/${userId}`, defaults);
  },

  getCompanyPrecisionLevel() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/customer_company/precision_level', defaults);
  },
  setCompanyPrecisionLevel(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/customer_company/precision_level', Object.assign(defaults, { data }));
  },
  getCustomPrecisionLevel() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/customer_company/custom_precision_level', defaults);
  },
  setCustomPrecisionLevel(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/customer_company/custom_precision_level', Object.assign(defaults, { data }));
  },
  signOut(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/sign_out', Object.assign(defaults, { data }));
  },
  getExtendToken() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/extend', defaults);
  },
  checkIsNotification() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/notification', defaults);
  },
  getNotificationList() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/notification/list', defaults);
  },
  recoveryEmailWithProfile(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/recovery_email', Object.assign(defaults, { data }));
  },
  getUserLocaleValue() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/locale', defaults);
  },
  setUserLocaleValue(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/locale', Object.assign(defaults, { data }));
  },
  getUserNotifications() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/notification_setting', defaults);
  },
  setUserNotifications(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/users/me/notification_setting', Object.assign(defaults, { data }));
  },
};

export default users;
